import { Link } from 'react-router-dom'
import * as routes from '../../routes'

const HashtagLink = ({hashtag_id}) => {
  return <Link to={routes.dynamic(routes.adminHashtagEditPath, hashtag_id)}>#{hashtag_id}</Link>
}

export default HashtagLink
